module.exports = __webpack_public_path__ + "static/img/video.7cc9693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.jpg
// module id = 975
// module chunks = 14